import { useNavigate, Link, useParams } from "react-router-dom";

import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';

import {
  Box,
  IconButton,

} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { HomeRounded } from '@mui/icons-material';

import SearchBar from "./searchBar"

/**
 * 
 * @param {*} param0 
 * @returns 
 */
export default function MenuBar({ menuItems, searchBar = true }) {
  const navigate = useNavigate();
  const { category } = useParams();

  const generateMenuItems = (menuItems) => {
    return menuItems.map((item) => {
      let selectedMenuItem = ""
      if (category && item.code === category) selectedMenuItem = "-hover-permanente"
      return (
        <Nav.Link className={'btn-navbar' + selectedMenuItem} key={item.name} onClick={() => navigate(`/catalog/${item.code}`)}>
          <span className='d-flex align-items-center'>{item.name}</span>
        </Nav.Link>
      );
    });
  };

  return (
    <Navbar className="navbar" variant="dark" expand="lg">
      <div className="container-xxl">
        <Navbar.Brand>
          <Link to="/catalog" className='btn-navbar'>
            <IconButton className='btn-navbar'>
              <HomeRounded sx={{ fontSize: 30, color: "FFFFFF" }} />
            </IconButton>
          </Link>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll">
          <MenuIcon />
        </Navbar.Toggle>
        {/* -------------------- START NAVBAR COLLAPSE -------------------- */}
        <Navbar.Collapse className='menu-bar' id="navbarScroll">
          <Nav className="menu-buttons mr-auto my-2 my-lg-0" navbarScroll>
            {/* -------------------- START MENU ITEMS -------------------- */}
            {menuItems && generateMenuItems(menuItems)}
            {/* -------------------- END MENU ITEMS -------------------- */}
          </Nav>
          {/* -------------------- START USER -------------------- */}
          <Box sx={{ flexGrow: 0 }} className="navbar-box-user">
            {searchBar && <SearchBar placeholder={"Buscar modelo"} />}
          </Box>
          {/* -------------------- END USER -------------------- */}
        </Navbar.Collapse>
        {/* -------------------- END NAVBAR COLLAPSE -------------------- */}
      </div>
    </Navbar>
  );

}